module.exports = __webpack_public_path__ + "static/img/code.990d5d50.jpg";